import { cn } from 'cn';
import * as React from 'react';

/** Page widths from the RIA theme breakpoints, Theme/index.ts:456-464. */
const WIDTHS = {
  lg: 'max-w-[var(--breakpoint-lg)]',
  xl: 'max-w-[var(--breakpoint-xl)]',
} as const;

type PageContainerProps = Omit<React.ComponentProps<'div'>, 'as'> & {
  as?: 'div' | 'article';
  width?: keyof typeof WIDTHS;
};

/**
 * Constrains content to a page width and applies the horizontal gutters.
 *
 * The RIA theme declares no MuiContainer override, so MUI's gutters resolve
 * through RIA's non-linear spacing scale to 8px at the smallest viewport and
 * 16px from the sm breakpoint (@mui/system/esm/Container/createContainer.js:60-65).
 */
function PageContainer({
  as: Component = 'div',
  width = 'lg',
  className,
  ...props
}: PageContainerProps) {
  return (
    <Component
      data-slot="page-container"
      className={cn('mx-auto w-full px-2 sm:px-4', WIDTHS[width], className)}
      {...props}
    />
  );
}

export { PageContainer };
